import * as React from 'react';
import styles from './ModalHeader.styl';
const ModalHeader = ({ t, field }) => {
    const isEdit = Object.values(field.defaults()).some(value => value !== null && value !== undefined && value !== '');
    return (React.createElement("div", { className: styles.textHeader }, t(`modalHeader`, { context: isEdit ? 'edit' : 'create', key: field.name })));
};
export default ModalHeader;
